import dayjs, {extend} from 'dayjs';
import utc from 'dayjs/plugin/utc';

extend(utc);

// Year
/** +1 year */
export const DefaultMaxYear = () => dayjs().add(1, 'year').year();

/** 1000 */
export const DefaultMinYear = () => dayjs('-001000-01-01').year();

// Date
/** +1 year */
export const DefaultMaxDate = () => dayjs().add(5, 'year').toISOString();

/** -1000-1-1 year */
export const DefaultMinDate = () => dayjs('-001000-01-01').toISOString();
